import { useQuery } from "@tanstack/react-query";
import { fetchFlavorSpecCatalog } from "@/services/flavor_api";

export function useFlavorSpecCatalog() {
  return useQuery({
    queryKey: ["flavor-spec-catalog"],
    queryFn: fetchFlavorSpecCatalog,
    staleTime: Infinity,
  });
}
